(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["solis-artwork-picker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('solis-artwork-picker')) {
    customElements.define('solis-artwork-picker', class extends HTMLElement {
      static productDraft = null;
      static get observedAttributes() { return ['data-id', 'data-handle']; }
      attributeChangedCallback() { if (this.isConnected) this.connectedCallback(); }
      connectedCallback() {
        queueMicrotask(() => { if (this.isConnected) this.initialise(); });
      }
      initialise() {
        this.abort?.abort();
        this.abort = new AbortController();
        const { signal } = this.abort;
        this.search = this.querySelector('input[type=search]');
        this.results = this.querySelector('[data-results]');
        this.status = this.querySelector('[data-search-status]');
        this.preview = this.querySelector('[data-preview]');
        this.searchArea = this.querySelector('[data-search-area]');
        this.root = window.Shopify.routes.root;
        this.dataset.pickerReady = 'true';
        this.search.addEventListener('input', () => {
          this.search.setCustomValidity('');
          this.loading = false;
          clearTimeout(this.timer);
          this.requestAbort?.abort();
          this.results.replaceChildren();
          const q = this.search.value.trim();
          this.status.textContent = q.length >= 2 ? this.dataset.searching : '';
          this.timer = setTimeout(() => this.find(q), 250);
        }, { signal });
        this.search.addEventListener('keydown', event => {
          if (event.key === 'Enter') { event.preventDefault(); this.results.querySelector('button')?.focus(); }
          if (event.key === 'ArrowDown') { event.preventDefault(); this.results.querySelector('button')?.focus(); }
          if (event.key === 'Escape') { this.results.replaceChildren(); this.status.textContent = ''; }
        }, { signal });
        this.results.addEventListener('keydown', event => {
          const buttons = [...this.results.querySelectorAll('button')];
          const index = buttons.indexOf(document.activeElement);
          if (event.key === 'ArrowDown') { event.preventDefault(); buttons[Math.min(index + 1, buttons.length - 1)]?.focus(); }
          if (event.key === 'ArrowUp') { event.preventDefault(); (buttons[index - 1] || this.search).focus(); }
          if (event.key === 'Escape') { this.results.replaceChildren(); this.search.focus(); }
        }, { signal });
        this.querySelector('[data-change]').addEventListener('click', () => {
          this.searchArea.hidden = false;
          this.search.value = '';
          this.search.focus();
        }, { signal });
        const saved = this.dataset.id ? { id:this.dataset.id, handle:this.dataset.handle, title:this.dataset.title, url:this.dataset.url, image:this.dataset.image } : null;
        this.setSelection(this.dataset.productForm === 'true' ? this.constructor.productDraft : saved, false);
        if (this.dataset.productForm === 'true' && !this.selection) {
          const handle = new URLSearchParams(location.search).get('artwork_handle');
          if (handle) this.choose(handle);
        }
      }
      disconnectedCallback() { this.abort?.abort(); this.requestAbort?.abort(); clearTimeout(this.timer); }
      eligible(p) { return p.handle !== 'custom-prints' && ['Art Print','Fine Art Print','Printable Material','Print Material'].includes(p.type || p.product_type) && !!(p.featured_image?.url || p.featured_image || p.image); }
      imageURL(value) {
        const url = new URL(value, location.origin);
        if (url.protocol !== 'https:' || !(url.hostname === 'cdn.shopify.com' || url.origin === location.origin)) throw new Error('Invalid artwork image');
        return url.href;
      }
      async find(q) {
        if (q.length < 2) return;
        this.requestAbort?.abort();
        this.requestAbort = new AbortController();
        try {
          const params = new URLSearchParams({ q, 'resources[type]':'product', 'resources[limit]':'10', 'resources[options][fields]':'title,vendor', 'resources[options][unavailable_products]':'show' });
          const response = await fetch(this.root + 'search/suggest.json?' + params, { signal:this.requestAbort.signal });
          if (!response.ok) throw new Error('Search failed');
          const data = await response.json();
          if (this.search.value.trim() !== q) return;
          this.results.replaceChildren();
          const products = (data.resources?.results?.products || []).filter(p => this.eligible(p));
          this.status.textContent = products.length ? '' : this.dataset.empty;
          for (const product of products) {
            const button = document.createElement('button');
            button.type = 'button'; button.dataset.result = ''; button.className = 'solis-artwork-result';
            const img = document.createElement('img');
            img.src = this.imageURL(product.image || product.featured_image.url); img.alt = ''; img.loading = 'lazy'; img.width = 48; img.height = 60;
            const title = document.createElement('span'); title.textContent = product.title;
            button.append(img, title);
            button.addEventListener('click', () => this.choose(product.handle, String(product.id)));
            this.results.append(button);
          }
        } catch (error) { if (error.name !== 'AbortError') this.status.textContent = this.dataset.error; }
      }
      async choose(handle, expectedId) {
        if (!/^[a-z0-9][a-z0-9-]*$/.test(handle)) return;
        this.requestAbort?.abort(); clearTimeout(this.timer);
        const request = new AbortController(); this.requestAbort = request;
        this.status.textContent = this.dataset.searching;
        this.loading = true;
        try {
          const response = await fetch(this.root + 'products/' + encodeURIComponent(handle) + '.js', { signal:request.signal });
          if (!response.ok) throw new Error('Artwork unavailable');
          const p = await response.json();
          if (!this.eligible(p) || (expectedId && String(p.id) !== expectedId)) throw new Error('Artwork mismatch');
          const image = this.imageURL(p.featured_image?.url || p.featured_image || p.image);
          const check = new Image(); check.src = image;
          await check.decode();
          if (request.signal.aborted || !this.isConnected) return;
          this.setSelection({ id:String(p.id), handle:p.handle, title:p.title, url:new URL(this.root + 'products/' + p.handle, location.origin).href, image });
          this.querySelector('[data-change]').focus();
        } catch (error) { if (error.name !== 'AbortError') this.status.textContent = this.dataset.previewError; }
        finally { if (this.requestAbort === request) this.loading = false; }
      }
      setSelection(value, notify = true) {
        this.selection = value?.id && value.image ? { ...value } : null;
        this.preview.hidden = !this.selection;
        this.searchArea.hidden = !!this.selection;
        this.results.replaceChildren(); this.status.textContent = '';
        this.search.setCustomValidity('');
        if (this.selection) {
          this.querySelector('[data-preview-image]').src = this.selection.image;
          this.querySelector('[data-preview-image]').alt = this.selection.title;
          this.querySelector('[data-preview-title]').textContent = this.selection.title;
        }
        const label = this.closest('.solis-custom-print-fields')?.querySelector('[data-artwork-label-value]');
        if (label) label.textContent = this.selection ? this.selection.title : label.dataset.notChosen;
        this.querySelectorAll('[data-property]').forEach(input => { input.value = this.selection?.[input.dataset.property] || ''; });
        if (this.dataset.productForm === 'true') this.constructor.productDraft = this.selection;
        if (notify) this.dispatchEvent(new CustomEvent('artwork:change', { bubbles:true }));
      }
      validateSelection() {
        if (this.selection?.id && !this.loading) return true;
        this.searchArea.hidden = false;
        this.search.setCustomValidity(this.loading ? this.dataset.searching : this.dataset.choose);
        this.search.reportValidity(); return false;
      }
    });
  }
  // Framia adopts AJAX section nodes from an inert parsed document. Explicitly
  // upgrade only newly inserted artwork components so their callbacks run.
  new MutationObserver(records => {
    for (const record of records) {
      for (const node of record.addedNodes) {
        if (!(node instanceof HTMLElement)) continue;
        if (node.matches('solis-artwork-picker, solis-custom-print-cart') || node.querySelector('solis-artwork-picker, solis-custom-print-cart')) customElements.upgrade(node);
      }
    }
  }).observe(document.body, { childList:true, subtree:true });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["solis-buy-box-extras"] && !Shopify.designMode) return;
  try {
    (function () {
    function decorate() {
      var pricesEl = document.querySelector('[data-solis-finish-prices]');
      var prices = {};
      if (pricesEl) {
        try {
          prices = JSON.parse(pricesEl.textContent) || {};
        } catch (error) {
          prices = {};
        }
      }

      var wrapper = document.querySelector('.solis-buy-box-extras');
      var template = wrapper ? wrapper.dataset.fromTemplate : '';

      var option1 = document.querySelector('#swatch-option1');
      if (option1 && template) {
        var items = option1.querySelectorAll('li[orig-value]');
        for (var i = 0; i < items.length; i++) {
          var item = items[i];
          var value = item.getAttribute('orig-value');
          if (value == null || !Object.prototype.hasOwnProperty.call(prices, value)) continue;

          var adjacent = item.querySelector('.swatch-img-text-adjacent');
          if (!adjacent || adjacent.querySelector('.solis-swatch-price')) continue;

          var span = document.createElement('span');
          span.className = 'solis-swatch-price';
          span.textContent = template.replace('__PRICE__', prices[value]);
          adjacent.appendChild(span);
        }

        var label = option1.querySelector('.swatch-option-name');
        if (label) {
          for (var n = 0; n < label.childNodes.length; n++) {
            var node = label.childNodes[n];
            if (node.nodeType === Node.TEXT_NODE && node.textContent.trim() === 'Product') {
              node.textContent = 'Finish';
              break;
            }
          }
        }
      }

      var option3 = document.querySelector('#swatch-option3');
      if (option3) {
        var frameItems = option3.querySelectorAll('li[orig-value]');
        var allBlank = true;
        for (var f = 0; f < frameItems.length; f++) {
          if (frameItems[f].getAttribute('orig-value') !== '-') {
            allBlank = false;
            break;
          }
        }
        if (allBlank && !option3.hidden) {
          option3.hidden = true;
        } else if (!allBlank && option3.hidden) {
          option3.hidden = false;
        }
      }
    }

    function scheduleDecorate() {
      if (scheduleDecorate.pending) return;
      scheduleDecorate.pending = true;
      requestAnimationFrame(function () {
        scheduleDecorate.pending = false;
        decorate();
      });
    }

    // Initial pass: the swatch app may already have rendered by the time
    // this script runs.
    decorate();

    // The swatch app re-renders its own markup on every selection change
    // (childList mutations), so observing structure - rather than importing
    // the theme's variant:update event - keeps this in sync for free.
    var root = document.querySelector('.swatches') || document.body;
    var observer = new MutationObserver(scheduleDecorate);
    observer.observe(root, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["solis-custom-print-cart"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('solis-custom-print-cart')) {
    customElements.define('solis-custom-print-cart', class extends HTMLElement {
      static get observedAttributes() { return ['data-key']; }
      attributeChangedCallback() { if (this.isConnected) this.connectedCallback(); }
      connectedCallback() {
        customElements.whenDefined('solis-artwork-picker').then(() => queueMicrotask(() => { if (this.isConnected) this.initialise(); }));
      }
      initialise() {
        this.abort?.abort();
        this.abort = new AbortController();
        const { signal } = this.abort;
        this.input = this.querySelector('solis-artwork-picker');
        this.status = this.querySelector('[data-status]');
        this.saveButton = this.querySelector('[data-save]');
        this.cancelButton = this.querySelector('[data-cancel]');
        this.saved = this.input.selection;
        this.saveButton.hidden = true;
        this.input.addEventListener('artwork:change', () => {
          this.cancelButton.hidden = !this.dirty;
          this.saveButton.hidden = !this.dirty;
          this.status.textContent = this.dirty ? this.dataset.unsaved : '';
        }, { signal });
        this.saveButton.addEventListener('click', () => this.save(), { signal });
        this.cancelButton.addEventListener('click', () => {
          this.input.setSelection(this.saved);
          this.saveButton.hidden = true;
          this.cancelButton.hidden = true;
          this.status.textContent = '';
        }, { signal });
        document.addEventListener('click', event => this.guard(event), { capture:true, signal });
        document.addEventListener('submit', event => this.guard(event), { capture:true, signal });
      }
      disconnectedCallback() { this.abort?.abort(); }
      get dirty() { return JSON.stringify(this.input.selection) !== JSON.stringify(this.saved); }
      guard(event) {
        if (!(event.target instanceof Element) || this.contains(event.target)) return;
        const action = event.target.closest('button, a, input, shopify-accelerated-checkout-cart');
        if (action?.matches('a[href*="/cart/change"]')) return;
        const checkout = action?.matches('[name="checkout"], a[href*="/checkout"], shopify-accelerated-checkout-cart') || (event.type === 'submit' && event.submitter?.name === 'checkout');
        const cartAction = action?.closest('cart-items-component, .cart-summary, .cart-drawer-summary') || (event.type === 'submit' && event.target.action?.includes('/cart'));
        if (!(checkout || cartAction) || !(this.dirty || this.busy || this.input.loading || !this.saved?.id)) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        this.status.textContent = this.busy ? this.dataset.saving : this.dataset.unsaved;
        this.input.querySelector('input[type=search]').focus();
      }
      async save() {
        if (this.busy) return;
        if (!this.input.validateSelection()) return;
        const value = this.input.selection;
        this.busy = true;
        this.input.inert = true;
        this.saveButton.disabled = true;
        this.cancelButton.disabled = true;
        this.status.textContent = this.dataset.saving;
        const root = window.Shopify.routes.root;
        try {
          const read = await fetch(root + 'cart.js', { headers:{ Accept:'application/json' } });
          if (!read.ok) throw new Error('Cart read failed');
          const cart = await read.json();
          const item = cart.items.find(item => item.key === this.dataset.key);
          if (!item || item.handle !== 'custom-prints') throw new Error('Cart line changed');
          const properties = { ...item.properties, Artwork:value.title, 'Artwork URL':value.url, _artwork_product_id:String(value.id), _artwork_handle:value.handle, _artwork_image:value.image };
          const sections = [];
          document.dispatchEvent(new CustomEvent('cart:grouped-sections', { detail:{ sections } }));
          const result = await fetch(root + 'cart/change.js', {
            method:'POST', headers:{ 'Content-Type':'application/json', Accept:'application/json' },
            body:JSON.stringify({ id:item.key, quantity:item.quantity, properties, sections:[...new Set(sections)].slice(0,5), sections_url:window.location.pathname })
          });
          if (!result.ok) throw new Error('Cart update failed');
          const updated = await result.json();
          const match = updated.items?.find(line => line.variant_id === item.variant_id && Object.entries(properties).every(([key, val]) => line.properties?.[key] === val));
          if (!match) throw new Error('Artwork readback failed');
          this.setAttribute('data-key', match.key);
          this.saved = value;
          this.cancelButton.hidden = true;
          this.status.textContent = this.dataset.saved;
          this.busy = false;
          document.dispatchEvent(new CustomEvent('cart:update', { bubbles:true, detail:{ resource:updated, sourceId:'custom-print-artwork', data:{ sections:updated.sections, itemCount:updated.item_count, isIncremental:false } } }));
        } catch {
          this.status.textContent = this.dataset.error;
        } finally {
          this.busy = false;
          this.input.inert = false;
          this.saveButton.disabled = false;
          this.cancelButton.disabled = false;
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["solis-custom-print-stage"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('solis-custom-print-stage')) {
    customElements.define('solis-custom-print-stage', class extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        const { signal } = this.abort;
        document.addEventListener('artwork:change', event => {
          const picker = event.target;
          if (!(picker instanceof Element) || !picker.matches('solis-artwork-picker[data-product-form="true"]')) return;
          this.render(picker.selection);
        }, { signal });
        customElements.whenDefined('solis-artwork-picker').then(() => setTimeout(() => {
          if (!this.isConnected) return;
          const p = document.querySelector('solis-artwork-picker[data-product-form="true"]');
          if (p && p.selection) this.render(p.selection);
        }, 0));
      }
      disconnectedCallback() { this.abort?.abort(); }
      render(selection) {
        const img = this.querySelector('[data-stage-image]');
        const empty = this.querySelector('[data-stage-empty]');
        if (!selection) {
          img.hidden = true;
          empty.hidden = false;
          return;
        }
        const u = new URL(selection.image);
        if (u.hostname === 'cdn.shopify.com') u.searchParams.set('width', '1400');
        img.src = u.href;
        img.alt = selection.title;
        img.hidden = false;
        empty.hidden = true;
        const s = document.querySelector('sticky-add-to-cart .sticky-add-to-cart__image img');
        if (s) {
          if (u.hostname === 'cdn.shopify.com') u.searchParams.set('width', '240');
          s.removeAttribute('srcset');
          s.src = u.href;
          s.alt = selection.title;
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["solis-delivery-date"] && !Shopify.designMode) return;
  try {
    class SolisDeliveryDate extends HTMLElement {
    connectedCallback() {
      this.render();
      // Framia morphs the section on variant change and writes the server
      // fallback text back into this element without reconnecting it, so
      // re-render whenever our own text is replaced.
      this.observer = new MutationObserver((mutations) => {
        if (this.rendering) return;
        const attributeChanged = mutations.some((mutation) => mutation.type === 'attributes');
        if (attributeChanged || (this.lastRendered && this.textContent !== this.lastRendered)) this.render();
      });
      // data-max changes when the shopper switches between a print and a framed finish.
      this.observer.observe(this, { childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ['data-min', 'data-max'] });
    }
    disconnectedCallback() { this.observer?.disconnect(); }
    render() {
      try {
        const maxDays = parseInt(this.dataset.max, 10);
        const cutoffHour = parseInt(this.dataset.cutoffHour, 10);
        const template = this.dataset.template;

        if (!Number.isFinite(maxDays) || !template) return;

        const now = new Date();
        const start = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        if (Number.isFinite(cutoffHour) && now.getHours() >= cutoffHour) {
          start.setDate(start.getDate() + 1);
        }

        const deliveryDate = this.#addBusinessDays(start, maxDays);
        const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
        const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        const formatted = days[deliveryDate.getDay()] + ' ' + deliveryDate.getDate() + ' ' + months[deliveryDate.getMonth()];

        this.rendering = true;
        this.textContent = ' · ' + template.replace('__DATE__', formatted);
        this.lastRendered = this.textContent;
        this.rendering = false;
      } catch (error) {
        // Leave the server-rendered fallback text (business-day range) in place.
      }
    }

    /**
     * @param {Date} date
     * @param {number} days
     * @returns {Date}
     */
    #addBusinessDays(date, days) {
      const result = new Date(date.getTime());
      let added = 0;
      while (added < days) {
        result.setDate(result.getDate() + 1);
        const day = result.getDay();
        if (day !== 0 && day !== 6) {
          added += 1;
        }
      }
      return result;
    }
  }

  if (!customElements.get('solis-delivery-date')) {
    customElements.define('solis-delivery-date', SolisDeliveryDate);
  }
  } catch(e) { console.error(e); }
})();

})();
